var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      "item-text": "key",
      label: _vm.label,
      disabled: _vm.disabled,
      clearable: _vm.clearable,
      "return-object": "",
      "hide-details": "",
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }